import { sumBy } from 'lodash-es';
import { useMemo } from 'react';
import { StatLabel } from 'src/components/Listings/InventoryEventPage/InventoryEventDetail/components/Map/StatLabel';
import { Content, useContent } from 'src/contexts/ContentContext';
import { Button, Stack } from 'src/core/ui';
import { flattenListingGroup } from 'src/modals/GroupListings/components/groupingUtils';
import { ContentId } from 'src/utils/constants/contentId';
import { IListingGroupItem, Listing, ListingGroup } from 'src/WebApiController';

export const MobileListingGroupStats = ({
  listingGroup,
  onOpenActions,
}: {
  listingGroup: ListingGroup;
  onOpenActions: () => void;
}) => {
  const ofText = useContent(ContentId.Of);
  const soldTicketStats = useMemo(() => {
    const listings = flattenListingGroup(listingGroup).map(
      (l: IListingGroupItem): Listing => l as Listing
    );
    const soldQty = sumBy(listings, (l) => l.soldQty ?? 0);
    const totalQty = sumBy(listings, (l) => (l.soldQty ?? 0) + l.availQty);

    return `${soldQty.toLocaleString()} ${ofText.toLocaleLowerCase()} ${totalQty.toLocaleString()}`;
  }, [listingGroup, ofText]);
  return (
    <Stack
      direction="row"
      width="full"
      justifyContent="spaceBetween"
      alignItems="center"
    >
      <Stack direction="row" gap="m">
        <StatLabel
          stat={soldTicketStats}
          title={<Content id={ContentId.SoldTickets} />}
        />
        <StatLabel
          stat={
            listingGroup.unitCst?.disp ?? listingGroup.faceValue?.disp ?? ''
          }
          title={<Content id={ContentId.UnitCost} />}
        />
      </Stack>
      <Button shape="rect" variant="outline" onClick={onOpenActions}>
        <Content id={ContentId.Actions} />
      </Button>
    </Stack>
  );
};
